import { useDispatch } from "react-redux";
import React, { useState, useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import "./PaymentScreen.css";
import { showAlert } from "../../redux/Common/commonActions";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Autocomplete,
  TextField,
  Button,
} from "@mui/material";

const NewPaymentPopup = ({ data, handleClose, onSubmit }) => {
  const [paymentMethod, setPaymentMethod] = useState("");
  const [paymentAmount, setPaymentAmount] = useState("");
  const [paymentPercentage, setPaymentPercentage] = useState("");
  const [finalData, setFinalData] = useState({});
  let dispatch = useDispatch();
  const handleChange = (e) => {
    setPaymentMethod(e.target.value);
  };

  const handleInputChange = (e, type) => {
    const value = parseFloat(e.target.value);
    const positivePayAmount = Math.abs(data.lc_billamount); // Ensure the amount is positive
    const roundedPayAmount = Math.round(positivePayAmount); // Round to the nearest integer

    if (type === "Amount") {
      if (value > roundedPayAmount) {
        // Allowing a tolerance of +1
        dispatch(
          showAlert("Entered amount is greater than the bill amount", "error")
        );
      } else {
        setPaymentAmount(value);
      }
    } else if (type === "Percentage") {
      if (value <= 100) {
        setPaymentPercentage(value);
      } else {
        dispatch(showAlert("Percentage cannot exceed 100%", "error"));
      }
    }

  };

  const handleSubmit = () => {
    console.log(paymentMethod, paymentPercentage, paymentAmount, "lolo");
    if (paymentMethod === "Full") {
      const newData = { ...data };
      newData.Lc_FinalAmount = newData.lc_payamount;
      newData.percentage = 100;
      setFinalData(newData);
    } else if (
      paymentMethod !== "Full" &&
      (paymentPercentage || paymentAmount)
    ) {
      const newData = { ...data };

      newData.Lc_FinalAmount = newData.lc_payamount;

      if (paymentPercentage) {
        newData.Lc_FinalAmount = (data.lc_payamount * paymentPercentage) / 100;
        newData.lc_payamount = (data.lc_payamount * paymentPercentage) / 100;
        newData.percentage = paymentPercentage;
      } else {
        newData.Lc_FinalAmount =
          paymentAmount > 0 ? -1 * paymentAmount : paymentAmount;
        newData.lc_payamount =
          paymentAmount > 0 ? -1 * paymentAmount : paymentAmount;
        newData.percentage = (
          (paymentAmount / (-1 * data.lc_payamount)) *
          100
        ).toFixed(2);
      }

      if (Math.abs(data.lc_billamount) >= Math.abs(data.Lc_FinalAmount)) {
        setFinalData(newData);
      } else {
        dispatch(
          showAlert("Final Amount should lower than Pay Amount", "error")
        );
      }
    } else {
      dispatch(showAlert("Please Enter Amount or Percentage", "error"));
    }

  };

  useEffect(() => {
    if (paymentMethod === "Amount") {
      const positivePayAmount = Math.abs(data.lc_payamount);
      const roundedPayAmount = Math.round(positivePayAmount);
      setPaymentAmount(roundedPayAmount);
    }
  }, [paymentMethod, data.lc_payamount]);

  useEffect(() => {
    if (Object.keys(finalData).length !== 0 && onSubmit) {
      onSubmit(finalData);
    }
  }, [finalData, onSubmit]);

  const paymentOptions = [
    { value: "Full", label: "Pay in full" },
    { value: "Percentage", label: "Pay by percentage" },
    { value: "Amount", label: "Pay by amount" },
  ];

  const paymentMethodLabels = {
    Full: "Pay in full",
    Percentage: "Pay by percentage",
    Amount: "Pay by amount",
  };

  return (
    <Box>
      <Dialog open={true} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle style={{ fontSize: "1rem" }}>
          Please select any one to proceed further
        </DialogTitle>

        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Typography variant="body1" sx={{ width: 120 }}>
                Payment type
              </Typography>
              <Autocomplete
                options={paymentOptions}
                value={
                  paymentMethod
                    ? {
                      value: paymentMethod,
                      label: paymentMethodLabels[paymentMethod],
                    }
                    : null
                }
                onChange={(event, newValue) => {
                  handleChange({ target: { value: newValue?.value || "" } });
                }}
                getOptionLabel={(option) => option.label}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select" size="small" />
                )}
                sx={{ flex: 1 }}
              />
            </Box>

            {(paymentMethod === "Percentage" || paymentMethod === "Amount") && (
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 2, mt: 2 }}
              >
                <Typography variant="body1" sx={{ width: 120 }}>
                  Enter{" "}
                  {paymentMethod === "Percentage" ? "Percentage" : "Amount"}
                </Typography>
                <TextField
                  type="number"
                  value={
                    paymentMethod === "Percentage"
                      ? paymentPercentage
                      : paymentAmount
                  }
                  onChange={(e) => handleInputChange(e, paymentMethod)}
                  size="small"
                  sx={{ flex: 1 }}
                />
              </Box>
            )}
          </Box>
        </DialogContent>

        <DialogActions
          sx={{ display: "flex", justifyContent: "center", gap: 2 }}
        >
          <Button color="success" variant="contained" onClick={handleSubmit}>
            Submit
          </Button>
          <Button color="error" variant="contained" onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default NewPaymentPopup;
